<ngx-spinner
    bdColor="rgba(75, 55, 100, 0.5)"
    size="large"
    color="#fff"
    type="line-scale-pulse-out">
        <span class="chevron left"></span>
        <span class="chevron right"></span>
</ngx-spinner>

<div class="m-grid__item m-grid__item--fluid m-wrapper ">
    <div class="m-content">
        <div class="m-portlet">
            <form
                [formGroup]="form" *ngIf="form">
                <div *ngIf="!eventSelection" style="padding: 5%">
                    <div class="title-prompt">
                        <h2>
                            Welcome to the CUE Fundraising Reports Wizard. <br>
                            What kind of report are you looking for today?
                        </h2>
                    </div>
                    <div class="options">
                        <div>
                            <button class="btn btn-success" (click)="setReportType(reportType.FinancialReport)">
                                Financial
                            </button>
                        </div>
                        <div>
                            <button class="btn btn-success" (click)="setReportType(reportType.WhosPlaying)">
                                Who's Playing?
                            </button>
                        </div>
                        <div>
                            <button class="btn btn-success" (click)="setReportType(reportType.PurchaseDetails)">
                                Purchase Details
                            </button>
                        </div>
                        <div style="margin-top: 5%">
                            <a [routerLink]="['saved']">
                                <button class="btn btn-success">
                                    Saved Reports
                                </button>
                            </a>
                        </div>
                    </div>
                </div>
                <div *ngIf="eventSelection" style="padding: 5%">
                    <div class="title-prompt" style="margin-bottom: 5%">
                        <h3>
                            Which events would you like to include in your report?
                        </h3>
                    </div>
                    <div class="event-selection">
                        <div [hidden]="!filteredEvents.length" class="select">
                            <div *ngFor="let event of filteredEvents; let i = index;" style="display: flex;">
                                <chunky-check-box [checked]="selectedEvents.includes(event)" (changed)="onSelectEvent(filteredEvents[i])"></chunky-check-box>
                                <label style="margin-left: 5%;">
                                    {{event.event.name}}
                                </label>
                            </div>
                        </div>
                        <div [hidden]="filteredEvents.length">
                            <label class="text-danger">
                              No events found
                            </label>
                        </div>
                        <div style="display: flex; padding-top: 5%; justify-content: center; flex-direction: column;">
                            <div style="display: flex; justify-content: center;">
                                <label style="align-self: center; margin-right: 2%;">
                                Select All Events
                                </label>
                                <div>
                                    <label class="switch">
                                    <input
                                        type="checkbox"
                                        formControlName="allEvents"
                                        (change)="onSelectAllEvents()"
                                        />
                                    <span class="slider round"></span>
                                    </label>
                                </div>
                            </div>
                            <label style="margin-bottom: 15px;">Or</label>
                            <div style="display: flex; justify-content: center;">
                                <label style="margin-right: 10px;">Specify a date range: </label>
                                <input formControlName="startRange" style="margin-right: 10px;" type="date"/>
                                <input formControlName="endRange" type="date" [min]="form.controls.startRange.value"/>
                                <a *ngIf="form.controls.startRange.value || form.controls.endRange.value" (click)="clearDateRange()" href="#" class="m-menu__link" style="text-decoration: none; margin-top: 5px; position: relative; left: 8px;">
                                    <i class="m-menu__link-icon flaticon-cancel"></i>
                                </a>
                            </div>
                        </div>
                    </div>
                    <div style="display: flex; justify-content: space-between;">
                        <button class="btn btn-danger" (click)="toggleEventSelection()">
                            Go Back
                        </button>
                        <button *ngIf="selectedEvents.length > 0 || (form.controls.startRange.value && form.controls.endRange.value)" class="btn btn-success" (click)="proceed()">
                            Next
                        </button>
                    </div>
                </div>
            </form>
        </div>
    </div>
</div>
